module.exports = __webpack_public_path__ + "img/dczj_paimai.7d147f2d.png";